import React from 'react';
import { Box, Container, Typography, Link, Divider, IconButton, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import Grid from '../utils/GridWrapper';

// Import the logo from the assets folder
import logo from '../assets/ewasko_consulting_cloud_logo.png';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <Box component="footer" sx={{ bgcolor: 'primary.main', color: 'white', py: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <img 
                src={logo} 
                alt="Ewasko Consulting Logo" 
                style={{ height: '35px', marginRight: '10px' }} // Adjust height as needed
              />
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                EWASKO CONSULTING
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
              Expert consulting in Product Management, Strategy, Product Market Fit, 
              Engineering and Operations with 20 years of industry experience.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton
                aria-label="LinkedIn"
                component="a"
                href="https://www.linkedin.com/in/todewasko/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'white', '&:hover': { color: 'secondary.light' } }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                aria-label="Email"
                component="a"
                href="mailto:todfather@gmail.com"
                sx={{ color: 'white', '&:hover': { color: 'secondary.light' } }}
              >
                <EmailIcon />
              </IconButton>
            </Stack>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Company
            </Typography>
            <Link 
              component={RouterLink} 
              to="/about" 
              color="inherit"
              sx={{ display: 'block', mb: 1, opacity: 0.8, '&:hover': { opacity: 1 } }}
              underline="hover"
            >
              About
            </Link>
            <Link 
              component={RouterLink} 
              to="/services" 
              color="inherit"
              sx={{ display: 'block', mb: 1, opacity: 0.8, '&:hover': { opacity: 1 } }}
              underline="hover"
            >
              Services
            </Link>
            <Link 
              component={RouterLink} 
              to="/experience" 
              color="inherit"
              sx={{ display: 'block', mb: 1, opacity: 0.8, '&:hover': { opacity: 1 } }}
              underline="hover"
            >
              Experience
            </Link>
          </Grid>
          
          {/* Removed Resources Section */}
          {/* 
          <Grid item xs={12} md={2}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Resources
            </Typography>
            <Link 
              component={RouterLink} 
              to="/blog" 
              color="inherit"
              sx={{ display: 'block', mb: 1, opacity: 0.8, '&:hover': { opacity: 1 } }}
              underline="hover"
            >
              Blog
            </Link>
            <Link 
              component={RouterLink} 
              to="/case-studies" 
              color="inherit"
              sx={{ display: 'block', mb: 1, opacity: 0.8, '&:hover': { opacity: 1 } }}
              underline="hover"
            >
              Case Studies
            </Link>
            <Link 
              component="a" 
              href="/resources/whitepaper.pdf"
              target="_blank" 
              color="inherit"
              sx={{ display: 'block', mb: 1, opacity: 0.8, '&:hover': { opacity: 1 } }}
              underline="hover"
            >
              Whitepaper
            </Link>
          </Grid>
          */}
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Contact
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, opacity: 0.8 }}>
              Email: todfather@gmail.com
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, opacity: 0.8 }}>
              Phone: Available upon request
            </Typography>
            <Link 
              component={RouterLink} 
              to="/contact" 
              color="inherit"
              sx={{ 
                display: 'inline-block', 
                mt: 1, 
                fontWeight: 600,
                opacity: 0.9, 
                '&:hover': { 
                  opacity: 1,
                  color: 'secondary.light'
                } 
              }}
              underline="hover"
            >
              Get in Touch →
            </Link>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.2)' }} />
        
        <Box sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'space-between' }, flexWrap: 'wrap' }}>
          <Typography variant="body2" sx={{ opacity: 0.8, mb: { xs: 1, sm: 0 } }}>
            © {currentYear} Ewasko Consulting. All rights reserved.
          </Typography>
          <Box>
            <Link 
              component={RouterLink} 
              to="/privacy" 
              color="inherit" 
              sx={{ opacity: 0.8, '&:hover': { opacity: 1 } }}
              underline="hover"
            >
              Privacy Policy
            </Link>
            <Typography component="span" sx={{ mx: 1, opacity: 0.8 }}>•</Typography>
            <Link 
              component={RouterLink} 
              to="/terms" 
              color="inherit" 
              sx={{ opacity: 0.8, '&:hover': { opacity: 1 } }}
              underline="hover"
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;